var _defs, _path, _path2, _circle, _path3, _path4, _path5, _polygon, _circle2, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _polygon2, _path11, _line, _line2, _line3, _path12, _polygon3, _path13, _line4, _line5, _line6, _path14, _path15, _line7, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon4, _path24, _path25, _line8, _line9, _line0, _line1, _path26, _polygon5, _line10, _line11, _line12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Error(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 632.05 378.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef9e7b;}.cls-2{fill:#fc3;}.cls-17,.cls-18,.cls-3,.cls-7,.cls-8{fill:none;}.cls-3{stroke:#fc3;}.cls-17,.cls-18,.cls-3,.cls-8{stroke-miterlimit:10;}.cls-4{fill:#d67f61;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#060e38;}.cls-7{stroke:#060e38;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.84px;}.cls-8{stroke:#ffdabc;}.cls-17,.cls-18,.cls-8{stroke-width:1.13px;}.cls-9{fill:#012442;}.cls-10{fill:#005482;}.cls-11{clip-path:url(#clip-path-2);}.cls-12{fill:#03081d;}.cls-13{fill:#f7f4ed;}.cls-14{fill:#d80650;}.cls-15{fill:#f03c3a;}.cls-16{fill:#d9004b;}.cls-17{stroke:#f2b77c;}.cls-18{stroke:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-3.82 -3.56)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 298.35,
    cy: 39.43,
    r: 16.97
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-3.82 -3.56)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.78,131.83c-17.41.44-37.25-12.39-53.5-27.89-4.81-4.58-2.16-7,2.42-11.78a12,12,0,0,1,17-.4c12.54,12,24.91,17.27,36.8,15.77,22.08-2.77,37.72-27.39,37.88-27.64a12,12,0,0,1,20.45,12.66c-.87,1.41-21.65,34.51-55.16,38.83A58.59,58.59,0,0,1,289.78,131.83Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.85,251.68H8.57L3.82,208.33l90-124.12h70.67v120H189.1v47.51H164.46v36.23H106.85Zm0-47.51V143L62.91,204.17Z",
    transform: "translate(-3.82 -3.56)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M553.62,251.68H455.34l-4.75-43.35,90-124.12h70.67v120h24.64v47.51H611.23v36.23H553.62Zm0-47.51V143l-43.94,61.16Z",
    transform: "translate(-3.82 -3.56)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 318.76,
    cy: 184.64,
    r: 108.32,
    transform: "translate(-41.02 275.91) rotate(-45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.09,184.64A120.37,120.37,0,0,1,318.72,305",
    transform: "translate(-3.82 -3.56)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M431.08,62.12A8.48,8.48,0,1,1,423,53.24,8.47,8.47,0,0,1,431.08,62.12Z",
    transform: "translate(-3.82 -3.56)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.78,50.05c.34,1.11,16.25,22.73,15.93,22.17L324,59,305.14,44.4Z",
    transform: "translate(-3.82 -3.56)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "304.06 40.02 301.88 59.17 292.53 46.01 304.06 40.02"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 294.53,
    cy: 35.86,
    r: 16.97
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.28,28.49s2.29,7.86,16,11.64l3.1,1.49s7,12.32,18.91,7.27c0,0,4.3-14.7-13.35-25.46C295.09,15.62,283.28,28.49,283.28,28.49Z",
    transform: "translate(-3.82 -3.56)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.94,46.62l-.65,4.07a.69.69,0,0,0,.85.79l2.75-.65Z",
    transform: "translate(-3.82 -3.56)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.5,39.41a5.42,5.42,0,1,1-5.17-5.65A5.41,5.41,0,0,1,308.5,39.41Z",
    transform: "translate(-3.82 -3.56)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M301,41a4,4,0,0,1,3.38-4.16",
    transform: "translate(-3.82 -3.56)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,22.41A11.65,11.65,0,1,1,318.06,11,11.65,11.65,0,0,1,330,22.41Z",
    transform: "translate(-3.82 -3.56)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286,43.06a1,1,0,1,1-1.28-.61A1,1,0,0,1,286,43.06Z",
    transform: "translate(-3.82 -3.56)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M282.91,39.77a3.4,3.4,0,0,1,3.59-.35",
    transform: "translate(-3.82 -3.56)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M288.67,51.74s0-1.29,1.75-1.43",
    transform: "translate(-3.82 -3.56)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "389.29 316.62 403.05 326.41 411.25 311.66 397 301.45 389.29 316.62"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M402.51,331.25l13-18.33L435,326.18,410.2,361a2,2,0,0,1-3.53-1.32l3.06-23.15Z",
    transform: "translate(-3.82 -3.56)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 402.65,
    y1: 355.56,
    x2: 427.79,
    y2: 320.21
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 404.06,
    y1: 343.62,
    x2: 407.55,
    y2: 342.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 404.65,
    y1: 339.09,
    x2: 408.15,
    y2: 337.87
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M350.39,148.33l-36.12,6.26S282.78,252,389.82,327.67c0,0,11.61-8.77,21-25.84,0,0-82-49.33-60.45-153.5",
    transform: "translate(-3.82 -3.56)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.65 339.57 264.65 356.45 282.02 356.45 282.08 338.92 264.65 339.57"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.3,358.45h22.5l.47,23.53H245.49a2,2,0,0,1-1-3.65l20.64-10.92Z",
    transform: "translate(-3.82 -3.56)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 241.07,
    y1: 374.27,
    x2: 284.45,
    y2: 374.27
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 251.61,
    y1: 368.5,
    x2: 254.62,
    y2: 370.64
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 255.65,
    y1: 366.36,
    x2: 258.66,
    y2: 368.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M312.52,125.17l1.49,7.46s-50.5,72.54-53.05,215c0,0,17.59,3.87,32.72,0,0,0-2-120.3,48.09-175.19,0,0,23.52-19.66,10.12-51.63Z",
    transform: "translate(-3.82 -3.56)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M261.23,337.39a149,149,0,0,0,32.56,0",
    transform: "translate(-3.82 -3.56)"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 310.55,
    y1: 129.01,
    x2: 350.63,
    y2: 125.39
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.78,131.83c-17.41.44-37.25-12.39-53.5-27.89-4.81-4.58-2.16-7,2.42-11.78a12,12,0,0,1,17-.4c12.54,12,24.91,17.27,36.8,15.77,22.08-2.77,37.72-27.39,37.88-27.64a12,12,0,0,1,20.45,12.66c-.87,1.41-21.65,34.51-55.16,38.83A58.59,58.59,0,0,1,289.78,131.83Z",
    transform: "translate(-3.82 -3.56)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "304.2 93.41 303.55 132.66 333.39 122.66 315.7 87.62 304.2 93.41"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.11,96.36l-.45-3.85,1.68.77-5.29-10.6a5.91,5.91,0,0,0-1.84-2.24c-1.84-1.3-3.31-.73-4.63-.87-2.2-.24-1.52.42-1.56,2.64h0c-2.3,0-7.06,1.07-9.67-9.11a4.15,4.15,0,0,0-5-3c-3.3.83,2.42-.7,2.26.79v.19a3.27,3.27,0,0,0-5.51,2.58,3.17,3.17,0,0,0-1.62,0A3.28,3.28,0,0,0,222,76.49a3.46,3.46,0,0,0,.08,1.15c0,.13.08.26.11.4l-.17,0c-1.38.34-1.44,1-1.59,2.29a3.4,3.4,0,0,0,.08,1.14,24.57,24.57,0,0,0,2.51,6.2h0l0,.1a25.35,25.35,0,0,0,1.65,2.79c3.33,5.31,11.68,15.71,21.18,18C258.54,111.75,256.11,96.36,256.11,96.36Z",
    transform: "translate(-3.82 -3.56)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M215.34,65.45l.06,1.9A2.68,2.68,0,0,0,216,69l23.76,28.51a4.73,4.73,0,0,0,3,1.83L253.21,99a3.68,3.68,0,0,0,2.91-2.51h0L224.84,66.47Z",
    transform: "translate(-3.82 -3.56)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.61,66.17l26,30.47a2.73,2.73,0,0,0,2.11,1L255,97.47a1,1,0,0,0,.77-1.7L229.87,65.62a3.65,3.65,0,0,0-2.82-1.27l-10.67.12A1,1,0,0,0,215.61,66.17Z",
    transform: "translate(-3.82 -3.56)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.2,67.21l23.54,27.63a1.94,1.94,0,0,0,1.5.68l6.45-.07a.92.92,0,0,0,.68-1.52l-23-26.77a3.25,3.25,0,0,0-2.5-1.13l-6.15.07A.67.67,0,0,0,220.2,67.21Z",
    transform: "translate(-3.82 -3.56)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248,79.6l-5.73-.88A3.16,3.16,0,0,0,238.9,83h0a3.16,3.16,0,0,0,1.55,1.67l10.31,5-1.52-6.64Z",
    transform: "translate(-3.82 -3.56)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M308.49,73.18s-3.83-4.21,3.14-11.94c8-8.92,12.49-6.07,16.28-4.34Z",
    transform: "translate(-3.82 -3.56)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M351.89,120.77S341.1,105.38,342.5,93.4s4.29-32.94-12.29-38.31a21.32,21.32,0,0,0-13.71,6.34C311,66.2,297.88,79.59,304.87,93.82a21.16,21.16,0,0,0,2.62,4.2,155.37,155.37,0,0,0,5,27.15Z",
    transform: "translate(-3.82 -3.56)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "329.18 88.09 338.92 118.23 353.5 116.62 325.7 72.84 329.18 88.09"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.68,177.12a11.18,11.18,0,0,0,.3,1.53l-6,11a3.85,3.85,0,0,0,6.25,4.4l1.23-1.39c1.82,1.52,4,5.19-.92,15a3.35,3.35,0,0,0,5.28,4l.12-.15a3.35,3.35,0,0,0,5.61,2.08,2.86,2.86,0,0,0,.36-.41,3.31,3.31,0,0,0,1.24,1.1,3.36,3.36,0,0,0,3.8-.54,3.66,3.66,0,0,0,.7-.94c.06-.13.11-.25.18-.38a.75.75,0,0,0,.15.09,3.34,3.34,0,0,0,3.79-.54,3.3,3.3,0,0,0,.7-.94,37.89,37.89,0,0,0,2.95-7.64h0l0-.11A22.48,22.48,0,0,0,393,200c.78-5.14,1.73-15.21-1.07-23.16a12.09,12.09,0,0,0,0-2.88c-5.62-44.55-24.88-78.41-38.5-97.52L333,91.65C344.8,108.33,361.76,138.17,366.68,177.12Z",
    transform: "translate(-3.82 -3.56)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M339.16,58.88A12.71,12.71,0,1,0,321,76.72a136.82,136.82,0,0,1,12,14.93L353.4,76.41A156.31,156.31,0,0,0,339.16,58.88Z",
    transform: "translate(-3.82 -3.56)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 329.18,
    y1: 88.09,
    x2: 317.22,
    y2: 73.15
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 166.52,
    y1: 12.02,
    x2: 172.59,
    y2: 14.6
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 181.8,
    y1: 2.74,
    x2: 181.8,
    y2: 8.07
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 169.78,
    y1: 0.31,
    x2: 175.4,
    y2: 8.91
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.83,13.75H244a2.43,2.43,0,0,1,2.43,2.43v19.4A2.42,2.42,0,0,1,244,38H180.83a2.42,2.42,0,0,1-2.42-2.42V16.18a2.43,2.43,0,0,1,2.43-2.43Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "205.93 35.78 212.29 43 218.88 35.78 205.93 35.78"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 185.54,
    y1: 22.57,
    x2: 236.69,
    y2: 22.57
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 185.54,
    y1: 28.03,
    x2: 213.79,
    y2: 28.03
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 149.57,
    y1: 378.42,
    x2: 480.49,
    y2: 378.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404_ERROR.ef31c4f289d1ba3105c83f63c1743e4a.svg";
export { ForwardRef as ReactComponent };